export const DAY_OF_WEEK_TAB_ITEM_SIZE_PX = 30;
